/**
 * WCS 坐标下的原子 3D 规格（@tarikjabiri/dxf v2.8.9）。
 * 仅当深度/板厚为 >0 的有限数值时才创建规格；undefined 即纯 2D。
 */
/** 原子 3D 放置规格，undefined 表示 2D（不输出拉伸/厚度）。 */
export interface Dxf3DSpec {
  elevation: number
  thickness: number
}

/* ------------------------------------------------------------------ */
/*  工厂函数 — 仅当输入严格有效时返回规格                                */
/* ------------------------------------------------------------------ */

/** 板件轮廓（正面，整板厚度）。 */
export function outlineSpec(
  panelThick: number | undefined
): Dxf3DSpec | undefined {
  if (
    typeof panelThick !== 'number' ||
    !Number.isFinite(panelThick) ||
    panelThick <= 0
  )
    return undefined
  return { elevation: 0, thickness: -panelThick }
}

/** 正面加工特征（孔、槽、曲线孔、铣型）。 */
export function frontFeatureSpec(
  depth: number | undefined
): Dxf3DSpec | undefined {
  if (typeof depth !== 'number' || !Number.isFinite(depth) || depth <= 0)
    return undefined
  return { elevation: 0, thickness: -depth }
}

/** 背面加工特征，需有效板厚。 */
export function backFeatureSpec(
  depth: number | undefined,
  panelThick: number | undefined
): Dxf3DSpec | undefined {
  if (typeof depth !== 'number' || !Number.isFinite(depth) || depth <= 0)
    return undefined
  if (
    typeof panelThick !== 'number' ||
    !Number.isFinite(panelThick) ||
    panelThick <= 0
  )
    return undefined
  return { elevation: -panelThick, thickness: depth }
}
